// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const MultiSelectContract = contract({
  name: "MultiSelect",
  description: "Picking multiple items from a finite list — tag selectors, filter chips,\n\"share with N people\", multi-region settings.\n\n**This is the answer for ANY \"removable-chips-inside-an-input\" pattern.**\nMultiSelect's trigger renders the current selection as Badges with X\nicons (the \"chip-in-trigger\" / \"chip-in-input\" shape), opens a Popover\nwith a searchable Command list, and supports \"+N more\" collapse past\n`maxCount`. Reach for it for:\n  - Linear-style filter bars (assignee, label, project chips inside one trigger)\n  - Slack channel pickers (selected channels as removable chips)\n  - Notion relation properties (related-page chips)\n  - GitHub label / assignee pickers\n  - tag / category / mention pickers anywhere\nDon't invent a `<ChipInput>` or `<TagInput>` for these — MultiSelect\nalready covers the trigger-with-badges shape.\n\nUse `<Select>` instead for SINGLE selection. Use `<Command>` directly\n(no MultiSelect wrapper) when the option set is unbounded or async\n(users to @-mention, email recipients, search-as-you-type API results).",
  import: "@gradeui/ui",
  composesWith: ["Popover","Command","Badge","Checkbox-style row indicator","Separator"],
  styleDefaults: {"MultiSelect":"mr-2 flex h-4 w-4 shrink-0 items-center justify-center rounded-sm border border-primary"},
  props: {
  "options": {
      schema: z.unknown(),
      design: "plumbing",
  },
  "value": {
      schema: z.string().optional(),
      design: "content",
      description: "controlled selection",
  },
  "defaultValue": {
      schema: z.string().optional(),
      design: "content",
      description: "uncontrolled initial selection",
  },
  "onValueChange": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
      default: "Select…",
  },
  "searchPlaceholder": {
      schema: z.string().optional(),
      design: "content",
      default: "Search…",
  },
  "emptyMessage": {
      schema: z.string().optional(),
      design: "content",
      default: "Nothing matches.",
  },
  "maxCount": {
      schema: z.number().optional(),
      design: "knob",
      description: "badges shown on the trigger before collapsing to \"+N more\"",
  },
  "searchable": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide for short option lists",
      default: true,
  },
  "badgeDismissible": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "show × on each selected badge",
      default: true,
  },
  "disabled": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "modalPopover": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "Popover modal mode",
      default: false,
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
